import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import LoadingIndicator from 'Components/UI/LoadingIndicator';

const useStyles = buildUseStyles('ContentLoading', (theme) => ({
  root: {
    marginTop: theme.spacing(15),
  },
}));

const ContentLoading = () => {
  const classes = useStyles();
  return (
    <Box
      className={classes.root}
    >
      <Text
        variant={'h5'}
        text={'Loading data...'}
      />
      <LoadingIndicator
        color={'primary'}
      />
    </Box>
  );
};

export default ContentLoading;
